export const DECORATIVE_APPROVAL_ORDER_REQUEST = "DECORATIVE_APPROVAL_ORDER_REQUEST"
export const DECORATIVE_APPROVAL_ORDER_SUCCESS = "DECORATIVE_APPROVAL_ORDER_SUCCESS";
export const DECORATIVE_APPROVAL_ORDER_FAILED = "DECORATIVE_APPROVAL_ORDER_FAILED";
